import { useAppSelector } from "./useAppSelector";
export const useDeviceResolution = () => {
    const { breakpointMatches } = useAppSelector((state) => state.app);
    return {
        isMobileResolution: breakpointMatches[639],
        isTabletResolution: breakpointMatches[1023],
        isLaptopResolution: breakpointMatches[1279],
    };
};
